import React from "react";
import aboutFront from "../assets/Vector 73 (1).svg";
import whoAreWe from "../assets/Image (2).svg";
import visionImg from "../assets/Image (3).svg";
import milestonesImg from "../assets/Image (1).svg";
import industry1 from "../assets/Group 195.svg";
import industry2 from "../assets/image 17.svg";
import industry3 from "../assets/Group 156 (1).svg";
import industry4 from "../assets/Group 157.svg";
import "../components/About/about.scss";

import Img1 from "../assets/aboutimages/Vector 36.svg";
import Img2 from "../assets/aboutimages/Group 56.svg";
import Img3 from "../assets/aboutimages/Group 55.svg";
import Img4 from "../assets/aboutimages/Vector 39.svg";
import Img5 from "../assets/aboutimages/Vector 40.svg";
import Img6 from "../assets/aboutimages/Group 57.svg";
import Img7 from "../assets/aboutimages/Vector 45.svg";
import Img8 from "../assets/aboutimages/Vector 36.svg";
import Img9 from "../assets/aboutimages/Group 158.svg";
import Img10 from "../assets/aboutimages/Vector 64.svg";
import Img11 from "../assets/aboutimages/Group 159.svg";
import Img12 from "../assets/aboutimages/Group 160.svg";
import Img13 from "../assets/aboutimages/Group 58.svg";
import Img14 from "../assets/aboutimages/Group 161.svg";
import Img15 from "../assets/aboutimages/Group 162.svg";
import Img16 from "../assets/aboutimages/Vector 52.svg";
import Img17 from "../assets/aboutimages/Vector 53.svg";
import Img18 from "../assets/aboutimages/Group 163.svg";
import Img19 from "../assets/aboutimages/Vector 55.svg";
import Img20 from "../assets/aboutimages/Group 167.svg";
import Img21 from "../assets/aboutimages/Group 164.svg";
import Img22 from "../assets/aboutimages/Group 165.svg";
import Img23 from "../assets/aboutimages/Vector 60.svg";
import Img24 from "../assets/aboutimages/Group 166.svg";
import { Zoom,Slide } from "react-awesome-reveal";

const industriesServed = [
  { name: "Iron And Steel", image: Img1 },
  { name: "Cement", image: Img2 },
  { name: "Pharmaceutical", image: Img3 },
  { name: "Textile and Infrastructure", image: Img4 },
  { name: "Agriculture", image: Img5 },
  { name: "Auto Component", image: Img6 },
  { name: "NBFCs", image: Img7 },
  { name: "Steel", image: Img8 },
  { name: "Chemicals", image: Img9 },
  { name: "Forging", image: Img10 },
  { name: "Green Energy", image: Img11 },
  { name: "Food & Beverages", image: Img12 },
  { name: "Hotel", image: Img13 },
  { name: "Automobiles", image: Img14 },
  { name: "Hospitals", image: Img15 },
  { name: "Papers", image: Img16 },
  { name: "Power", image: Img17 },
  { name: "Retail", image: Img18 },
  { name: "Micro", image: Img19 },
  { name: "Real Estate", image: Img20 },
  { name: "Finance", image: Img21 },
  { name: "Manufacturing", image: Img22 },
  { name: "Packaging", image: Img23 },
  { name: "Telecom", image: Img24 },
];

const AboutPage = () => {
  return (
    <div className="container about">
      <div className="about-image" style={{ position: "relative" }}>
        <img
          src={aboutFront}
          alt="About Front"
          style={{ objectFit: "cover" }}
        />
        <div className="aboutt-uss mb-0">
          <h3 className="text-center mb-0">About Us</h3>
        </div>
      </div>

      <div className="row who-we-are my-5">
        <div className="col-lg-6">
          <Zoom>

          <h2 className="fw-bolder">Who we are</h2>
          </Zoom>
          <p>
            Established in 2002, Varrenyam Consultants Pvt. Ltd. proudly
            operates in New Delhi and Mumbai. Our track record speaks volumes as
            we consistently deliver tangible results and offer committed,
            implementable solutions to our diverse clientele. With a focus on
            cost-effective and timely financial support, we boast strong
            affiliations with top legal firms, TAV Consultants, Valuers, IP
            Entities, Fund Houses, O&amp;M service providers, and Tech
            Consultants, fortifying our ability to provide comprehensive and
            well-rounded services.
          </p>
        </div>
        <div className="col-lg-6 text-center">
          <img src={whoAreWe} alt="Who We Are" style={{ width: "90%" }} />
        </div>
      </div>

      <div className="row vision my-5">
        <div className="col-lg-6 text-center">
          <img src={visionImg} alt="Vision" />
        </div>
        <div className="col-lg-6 vision-content">
          <Zoom>

          <h2 className="fw-bolder">Vision</h2>
          </Zoom>
          <p>
            To emerge as the premier ‘One Stop Financial Solution Provider’
            specializing in the resolution of distresses assets. Offering
            comprehensive expertise to navigate and optimize financial
            landscape.
          </p>
        </div>
      </div>

      <div className="row milestones my-4">
        <img src={milestonesImg} alt="Milestones" />
      </div>
<Zoom>

      <h2 className="my-3 fw-bolder">Milestones</h2>
</Zoom>
      <ul>
        <Slide direction="right" cascade damping={0.2}>
        <li>
          Successfully navigating the financial landscape, we have completed
          debt restructuring exceeding Rs 1 lakh Cr since our inception under
          the Corporate Debt Restructuring (CDR) scheme.
        </li>
        <li>
          Our dedicated team of Partners and Associates has adeptly resolved
          over 20 significant accounts, including those in the 'dirty dozen,'
          leveraging the Insolvency and Bankruptcy Code (IBC) and addressing
          more than Rs 2 lakh Cr in lenders' dues.
        </li>
        <li>
          Raised over Rs 5000 Cr in debt and equity from lenders and fund
          houses.
        </li>
        <li>
          Our achievements include the successful turnaround of a major steel
          account during the insolvency process, generating an impressive EBIDTA
          of over Rs. 4000 Cr during the Corporate Insolvency Resolution Process
          (CIRP) period.
        </li>
        <li>
          Our unique selling proposition (USP) lies in our ability to operate
          and manage separate corporate debtors as going concerns, resulting in
          turnaround success and delivering higher valuations to stakeholders.
        </li>
        </Slide>
      </ul>

      <div className="row">
        <h2 className="text-center my-5 fw-bolder">
          Industry Association and Membership
        </h2>
        <div className="container">
          <div className="row row-cols-2 industry">
            {[industry1, industry2, industry3, industry4].map((imgSrc, idx) => (
              <img
                key={idx}
                src={imgSrc}
                className="card-img-top"
                alt={`Industry ${idx + 1}`}
                />
            ))}
          </div>
        </div>
      </div>

      <div className="row industry-we-served">
        <Zoom>

        <h2 className="text-center my-5 fw-bolder">Industry we Served</h2>
        </Zoom>
        {industriesServed.map((industry, index) => (
          <div className="col-lg-2 col-md-3 col-sm-3 p-0" key={index}>
            <div
              className={`served-parts ${
                index >= industriesServed.length - 6 ? "border-bottom-0" : ""
              }`}
            >
              <img alt={industry.image} src={industry.image} />
              <p className="text-center py-2">{industry.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutPage;
